import "./Menu.css";

export default function DownloadSection() {
    return (
        <section
            className="download-section position-relative"
            style={{ backgroundImage: "url('./assets/back.jpg')" }}
        >
            <div className="container content-wrapper">
                <div className="row align-items-center justify-content-center">
                    {/* Left Column: Text and Buttons */}
                    <div className="col-12 col-lg-6 text-center text-lg-start">
                        <div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-4">
                            <span className="orange-line"></span>
                            <p className="text-uppercase tracking-widest mb-0">
                                Mobile Application
                            </p>
                        </div>
                        <h1 className="section-heading">
                            Download <br /> our application
                        </h1>
                        <p className="section-description">
                     Order from top restaurants, track in real-time, and enjoy exclusive deals — all in one easy-to-use app.
                        </p>
                        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                            <a href="https://play.google.com/store/apps/details?id=com.katchit.customer_app" className="app-store-btn">
                                <img
                                    src="./assets/play_store.avif"
                                    alt="Get it on Google Play"
                                    className="app-store-img"
                                />
                            </a>
                             <a href="https://apps.apple.com/in/app/katchit-customer/id6785157187" className="app-store-btn">
                                <img
                                    src="./assets/app_store.avif"
                                    alt="Get it on App Store"
                                    className="app-store-img"
                                />
                            </a>
                           
                        </div>
                    </div>

                    {/* Right Column: Mobile Phone Image */}
                    <div className="col-12 col-lg-6 d-flex justify-content-center justify-content-lg-end mt-5 mt-lg-0">
                        <img
                            src="../assets/phone.png"
                            alt="Mobile phone with food application"
                            className="img-fluid"
                            style={{ maxHeight: "600px", width: "auto" }}
                            width={400}
                            height={600}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
